import api from './api'

export async function getCommands() {
  const res = await api.get('/cron/commands')
  return res.data
}

export async function getCronJobs() {
  const res = await api.get('/cron')
  return res.data
}

export async function getCronById(id) {
  const res = await api.get('/cron/' + id)
  return res.data
}

export async function getCronExecutionsById(id) {
  const res = await api.get('/cron/run/' + id)
  return res.data
}

export async function updateCronById(id, data) {
  const res = await api.patch('/cron/' + id, data)
  return res.data
}

export async function createCron(data) {
  const res = await api.post('/cron', data)
  return res.data
}

export async function deleteCronById(id) {
  const res = api.delete('/cron/' + id)
  return res.data
}
